<template>
  <nav class="navbar" :class="{'navbar--night': $props.nightTheme}">
    <ccs-input type="text" v-model="search" class="navbar-search"
      iconName="search" placeholder="Начните ввод для поиска"/>
    <div v-if="!noOrdering" class="navbar-text">Сортировать по</div>
    <ccs-input v-if="!noOrdering" type="dropdown" class="navbar-order_field" :items="$props.orderFields"
      v-model="orderField" placeholder="Выберите поле"/>
    <div v-if="!noOrdering" class="navbar-text">в порядке</div>
    <ccs-input v-if="!noOrdering" type="dropdown" class="navbar-order_mode" :items="orderModes"
      :disabled="!orderField"
      v-model="orderMode" placeholder="Выберите тип" :modifiers="['no_cancel']"/>
    <slot/>
  </nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import Input from '@/components/forms/Input';

export default {
  name: 'NavBar',
  components: {
    'ccs-input': Input,
  },
  props: {
    dataFunction: {
      required: true,
      type: Function,
    },
    orderFields: {
      type: Array,
      default: () => [],
    },
    nightTheme: {
      type: Boolean,
      default: false
    },
    noOrdering: {
      type: Boolean,
      default: false
    },
    extraParams: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      orderModes: [{
        prop: 'asc',
        text: 'Возрастания',
      }, {
        prop: 'desc',
        text: 'Убывания',
      }]
    };
  },
  computed: {
    ...mapState('misc', ['navigation']),
    search: {
      get() {
        return this.navigation.search;
      },
      set(val) {
        this.setSearch(val);
        if (val.length >= 3 || val.length === 0) {
          this.$props.dataFunction();
        }
      },
    },
    orderField: {
      get() {
        return this.navigation.orderField;
      },
      set(val) {
        this.setOrderField(val);
        if (val) this.setOrderMode('asc');
        else this.setOrderMode(undefined);
        this.$props.dataFunction();
      },
    },
    orderMode: {
      get() {
        return this.navigation.orderMode;
      },
      set(val) {
        this.setOrderMode(val);
        this.$props.dataFunction();
      },
    },
  },
  methods: {
    ...mapMutations('misc', [
      'setSearch',
      'setOrderField',
      'setOrderMode',
      'setExtraParams',
    ]),
  },
  mounted() {
    this.setSearch(undefined);
    this.setOrderField(undefined);
    this.setOrderMode(undefined);
    this.setExtraParams(this.$props.extraParams);
  },
  watch: {
    extraParams(to) {
      this.setExtraParams(to);
      this.$props.dataFunction();
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;

  &-search {
    margin-right: 30px;
  }

  &-text {
    margin-right: 10px;
    font-weight: bold;
    font-size: 14px;
    white-space: nowrap;
  }

  &-order_field {
    margin-right: 10px;
  }

  &--night {

    .navbar-text {
      color: #fff;
    }

  }

}
</style>